module.exports = __webpack_public_path__ + "img/65.a064594f.png";